<template>
  <div
    class="d-flex align-items-center justify-content-center i-pb-11 w-100 h-100"
    data-testid="request-credit-insights-access"
  >
    <div
      class="d-flex flex-column i-p-8 w-100 request-credit-insights-cta-container"
    >
      <h1 class="d-flex flex-row i-text-heading-1 i-mb-4">Credit Insights</h1>
      <div class="i-text-body-2 credit-insights-description">
        Companies like Coast are using it to make fast, accurate, and fair
        underwriting decisions. Get access to Credit Insights to see how.
      </div>
      <div class="d-flex flex-row i-py-8">
        <i-button
          text="Request access"
          size="lg"
          type="primary"
          aria-label="Request access to Credit Insights"
          data-testid="credit-insights-request-access-button"
          @button-click="onClickGetCreditInsightsAccess()"
        />
      </div>
    </div>
    <div
      class="d-flex flex-column align-items-center justify-content-center h-100 credit-insights-preview-container"
    >
      <img
        src="../../img/credit-insights-ui-preview-with-fake-data.svg"
        class="h-100"
        alt="preview of the Credit Insights UI"
      />
    </div>
  </div>
</template>

<script>
import { iButton } from '@inscribe/signal';

export default {
  components: {
    iButton,
  },
  props: {},
  methods: {
    onClickGetCreditInsightsAccess() {
      this.navigateToMarketingWebsiteFeatureSignUpPage();
    },
    navigateToMarketingWebsiteFeatureSignUpPage() {
      window.location.href = 'https://www.inscribe.ai/feature-sign-up';
    },
  },
};
</script>

<style lang="scss" scoped>
.request-credit-insights-cta-container {
  min-width: 50px;
  max-width: 500px;
  h1 {
    color: #101e2e;
  }
}

.credit-insights-description {
  max-width: 384px;
  color: $light-neutral-120;
}
.credit-insights-preview-container {
  img {
    max-width: 100%;
  }
}
</style>
